import React, { useContext, useEffect, useState } from 'react'
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { PartialSpinny } from '../../Nav/Spinny';
import { FieldRenderProps } from '@progress/kendo-react-form';
import ClientTypeList from '../../ClientType/ClientTypeList';
import { RevUserContext, RevUserContextType } from '../../../context/UserContext';
import { FavoriteApi } from '../../../redux/api/FavoriteApi';
import { IFavoriteConfig } from '../../../types/Favorites/IFavoriteConfig';

export const SettingsDialog = (props: FeedDialogProps) => {
    const { profile } = React.useContext<RevUserContextType>(RevUserContext)
    const { data: apiConfig, isFetching } = FavoriteApi.useGetFavoriteConfigQuery(profile.Uid, { skip: !profile?.Features?.Revelations });
    const [settings, setSettings] = useState<IFavoriteConfig>({} as IFavoriteConfig)
    const [saveFavSettings, { isLoading: savingConfig }] = FavoriteApi.useSaveFavoriteConfigMutation();

    const saveClicked = async () => {
        //Save the feed config
        await saveFavSettings({ config: settings, uid: profile.Uid });

        props.onSaved();
    }

    //put the API data in state
    useEffect(() => {
        console.log('put the API data in state', apiConfig)
        if (apiConfig)
            setSettings(apiConfig);
    }, [apiConfig]);


    const clientTypeChanged = (e) => {
        console.log('client Type changed', e)
        setSettings((oldval) => {
            return { ...oldval, Client_Type_Ids: e.value.map(ct => ct.ID)?.join(',') }
        });
    }

    const emptyProps = {} as FieldRenderProps

    return (
        <Dialog title={"Contacts settings"} onClose={props.onClose} width={700} className={'feed-settings'}>
            {(!apiConfig || isFetching || !settings || savingConfig) &&
                <PartialSpinny />
            }
            <div className='flex flex-wrap m-3'>
                <div className='w-full flex flex-wrap'>
                    <div className='w-1/6 flex flex-col-reverse pb-1'>
                        <label>{profile?.Phrases.Client} Type/s</label>
                    </div>
                    <div className='w-4/6'>

                        <ClientTypeList {...emptyProps} clientTypeIds={settings.Client_Type_Ids?.split(',').map(t => parseInt(t))} onChange={clientTypeChanged} />
                    </div>
                </div>
            </div>
            <DialogActionsBar layout={'end'}>
                <button
                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary" style={{ color: '#fff', background: profile?.Nav_Hex_Color }}
                    onClick={saveClicked}>
                    Save
                </button>
                <button
                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                    onClick={props.onClose}>
                    Cancel
                </button>
            </DialogActionsBar>

        </Dialog >
    )
}

export type FeedDialogProps = {
    onClose: () => void
    onSaved: () => void
}